import React, {useCallback} from "react";
import {Form, Row, Col} from "react-bootstrap";
import {FormField, FormFieldHosting} from "../../forms";
import {useFormikContext} from "formik";

// Start tab, here are all the calculation options
const CalulationSettings = () => {
    const {setFieldValue, values} = useFormikContext()
    const {service_form_project_options} = values

    // Logic for handling checkbox changes
    const onOptionsChange = useCallback((id) => {
        const updatedOptions = service_form_project_options.map((option, index) =>
            index === id ? { ...option, value: !option.value } : option
        );

        // If storing is turned off, also turn off 24/7
        if (id === 3 && !updatedOptions[3].value) {
            updatedOptions[4].value = false;
        }

        // If storing 24/7 is turned on, also turn on storing
        if (id === 4 && updatedOptions[4].value) {
            updatedOptions[3].value = true;
        }

        setFieldValue("service_form_project_options", updatedOptions);
    }, [service_form_project_options, setFieldValue]);

    return <Row>
        <Col>
            <h4>Instellingen</h4>
            <FormField name={"service_form_project_building"}
                       label={"Gebouwen"}
                       className={"mb-3"}
                       control={"input"}
                       type={"number"}
                       min={0}
            />
            <FormField name={"service_form_project_ebs"}
                       label={"Regelkasten"}
                       className={"mb-3"}
                       control={"input"}
                       type={"number"}
                       min={0}
            />
            <FormField name={"service_form_project_nar"}
                       label={"Naregelingen"}
                       className={"mb-3"}
                       control={"input"}
                       type={"number"}
                       min={0}
            />
            <FormField name={"service_form_project_ios"}
                       label={"IO's"}
                       className={"mb-3"}
                       control={"input"}
                       type={"number"}
                       min={0}
            />
            {service_form_project_options[5].value && <FormFieldHosting name={["service_form_project_hosting"]}
                               label={"Hosting"}
                               className={"mb-3"}
                               control={"input"}
                               as={"select"}>
                <option value="">-</option>
                <option value="basis">basis</option>
                <option value="xl">XL</option>
            </FormFieldHosting>}
            <FormField name={"service_form_project_supplier"}
                       label={"Fabricaat"}
                       className={"mb-3"}
                       control={"input"}
                       as={"select"}
            >
                <option value="">-</option>
                <option value="DISTECH">DISTECH</option>
                <option value="EAGLEHAWK CENTRALINE">EAGLEHAWK CENTRALINE</option>
                <option value="EAGLEHAWK EAP">EAGLEHAWK EAP</option>
                <option value="HONEYWELL CENTRALINE">HONEYWELL CENTRALINE</option>
                <option value="PRIVA BLUE ID">PRIVA BLUE ID</option>
                <option value="SAIA EAP">SAIA EAP</option>
                <option value="SAIA PCD3">SAIA PCD3</option>
                <option value="SAIA RIO">SAIA RIO</option>
                <option value="div">DIVERSE</option>
            </FormField>
            {values.service_form_project_supplier === "div" && <FormField name={"service_form_project_supplier_div"}
                                                         className={"mb-3"}
                                                         control={"input"}
                                                         min={0}
            />}

        </Col>
        <Col>
            <h4>Calculatie opties</h4>
            {service_form_project_options.map((o, index) => (
                <Form.Check
                    key={o.id} // Ensure o.id is unique for each checkbox
                    className={"mb-3"}
                    label={o.label}
                    checked={o.value}
                    onChange={() => onOptionsChange(index)} // Pass index instead of id
                />
            ))}
        </Col>
    </Row>
}
export default CalulationSettings